import { render, staticRenderFns } from "./WorkspaceTheme.vue?vue&type=template&id=1600f7ce&scoped=true"
import script from "./WorkspaceTheme.vue?vue&type=script&lang=js"
export * from "./WorkspaceTheme.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTheme.vue?vue&type=style&index=0&id=1600f7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600f7ce",
  null
  
)

export default component.exports